/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface CloneDeviceFieldsDto {
  /** Space ID where this clone will be located */
  spaceId: string;
  /** Location ID where this clone will be located */
  locationId: string;
  /** Optional serial number for the cloned device */
  serialNumber?: string;
  /** Name to use for the clone */
  name: string;
}
